<template>
  <generic-container
    v-bind:searchable="false"
    v-bind:show_plus="true"
    icon="list"
    :title="title"
    v-on:add="add"
  >
    <div class="ui form">
      <slot></slot>
      <div class="fields" v-for="(attribute, index) in attributes" v-bind:key="index">
        <div class="fourteen column wide field">
          <input type="text" name="name" v-model="attributes[index]" />
        </div>
        <div class="two column wide field">
          <div class="ui mini red icon button" v-on:click="remove(attribute, index)">
            <i class="trash icon"></i>
          </div>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";

export default {
  filters: {},
  props: {
    title: String,
    attributes: Array
  },
  components: {
    "generic-container": GenericContainer
  },
  data() {
    return {
      // attributes: []
    };
  },
  methods: {
    add() {
      this.attributes.push("");
    },
    remove(attribute, index) {
      this.attributes.splice(index, 1);
    }
  },
  mounted() {},
  watch: {}
};
</script>
